import CryptoJS from 'crypto-js'

const API_SECRET_KEY = process.env.REACT_APP_API_SECRET_KEY ?? ''

export const generateSignature = (message: string) => {
  return CryptoJS.HmacSHA256(message, API_SECRET_KEY).toString(CryptoJS.enc.Hex)
}
